import { useState } from 'react';
import { useAppStore } from '../store/useAppStore.js';
import { AlertIcon } from '../icons.js';
import { PasswordField } from '../PasswordField.js';

export function SignInCard() {
  const signIn = useAppStore((s) => s.signIn);
  const setView = useAppStore((s) => s.setView);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signIn(email, password);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="card p-7 lg:p-10 has-grain">
      <h2 className="h-card mb-1 text-ink-900 dark:text-ink-100">Welcome back</h2>
      <p className="hint mb-6">Sign in with the email and password you signed up with.</p>

      <form onSubmit={onSubmit} autoComplete="on" className="flex flex-col gap-5">
        <label className="flex flex-col gap-2">
          <span className="field-label">Email</span>
          <input
            className="input"
            type="email"
            placeholder="you@email.com"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <PasswordField
          label="Password"
          value={password}
          onChange={setPassword}
          autoComplete="current-password"
          required
        />

        <div className="-mt-1 text-right">
          <button
            type="button"
            onClick={() => setView('forgot')}
            className="text-[0.85rem] text-ink-600 dark:text-[#b6b2c4] hover:underline"
          >
            Forgot password?
          </button>
        </div>

        <button type="submit" className="btn-primary w-full justify-center" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Enter the lobby →'}
        </button>
      </form>

      {error ? (
        <div className="notice-error mt-5">
          <AlertIcon className="shrink-0 mt-0.5" />
          <span>{error}</span>
        </div>
      ) : null}
    </div>
  );
}
